import { request } from "./APIUtils"

export const TT = { method: 'POST', url: process.env.REACT_APP_BASE_URL + 'tt' }
export const CHECK_TOKEN = { method: 'GET', url: process.env.REACT_APP_BASE_URL + 'user/check-token' }
export const NEXT_EVENT = { method: 'GET', url: process.env.REACT_APP_BASE_URL + 'event/next-event' }
export const EVENT_YEARS = { method: 'GET', url: process.env.REACT_APP_BASE_URL + 'event/event-years' }
export const GALLERY_YEARS = { method: 'GET', url: process.env.REACT_APP_BASE_URL + 'event/gallery-years' }
export const VIDEOS_YEARS = { method: 'GET', url: process.env.REACT_APP_BASE_URL + 'event/videos-years' }
export const GET_BILLETERIE_OPTIONS = { method: 'GET', url: process.env.REACT_APP_BASE_URL + 'event/billeterie-options' }
export const GET_RATE_OPTIONS = { method: 'GET', url: process.env.REACT_APP_BASE_URL + 'price/price-options' }
export const CHECK_PROMOTION_CODE = { method: 'POST', url: process.env.REACT_APP_BASE_URL + 'promotioncode/check-promotion-code' }
export const REGISTER_PAYMENT = { method: 'POST', url: process.env.REACT_APP_BASE_URL + 'payment/register-payment' }
export const GET_PAYMENT = { method: 'GET', url: process.env.REACT_APP_BASE_URL + 'payment/get-payment' }
export const PREPARE_PAYMENT = { method: 'POST', url: process.env.REACT_APP_BASE_URL + 'payment/prepare-payment' }
export const GET_PAYMENT_RESPONSE = { method: 'GET', url: process.env.REACT_APP_BASE_URL + 'payment/get-payment-response' }
export const LOGIN = { method: 'POST', url: process.env.REACT_APP_BASE_URL + 'user/login' }
export const FORGOT_PASSWORD = { method: 'POST', url: process.env.REACT_APP_BASE_URL + 'user/forgot-password' }
export const RESET_PASSWORD = { method: 'POST', url: process.env.REACT_APP_BASE_URL + 'user/reset-password' }
export const GET_ENTRANCE = { method: 'GET', url: process.env.REACT_APP_BASE_URL + 'entrance/get-entrance' }
export const SCANNED_ENTRANCE_LIST_FILTERS = { method: 'GET', url: process.env.REACT_APP_BASE_URL + 'entrance/scanned-entrance-list-filters' }
export const GET_SCANNED_ENTRANCE_LIST = { method: 'GET', url: process.env.REACT_APP_BASE_URL + 'entrance/get-scanned-entrance-list' }
export const EXPORT_SCANNED_ENTRANCES = { method: 'GET', url: process.env.REACT_APP_BASE_URL + 'entrance/scanned-entrance-export' }
export const LOGOUT = { method: 'POST', url: process.env.REACT_APP_BASE_URL + 'user/logout' }
export const GALLERY = { method: 'GET', url: process.env.REACT_APP_BASE_URL + 'event/event-gallery' }
export const GALLERY_VIDEO = { method: 'GET', url: process.env.REACT_APP_BASE_URL + 'event/event-videos' }
export const SAVE_EXPOSANT = { method: 'POST', url: process.env.REACT_APP_BASE_URL + 'exposant/request' }
// Workshops
export const GET_WORKSHOPS = { method: 'GET', url: process.env.REACT_APP_BASE_URL + 'workshop/event/{eventId}' }
export const GET_WORKSHOP = { method: 'GET', url: process.env.REACT_APP_BASE_URL + 'workshop/{workshopName}' }
export const GET_SECTOR_OPTIONS = { method: 'GET', url: process.env.REACT_APP_BASE_URL + 'event/sector-options' }
export const GET_ENTRANCES_BY_EMAIL = { method: 'GET', url: process.env.REACT_APP_BASE_URL + 'entrance/find-by-email' }
// Emails
export const GET_EMAILS = { method: 'GET', url: process.env.REACT_APP_BASE_URL + 'emails' }
export const PREVIEW_EMAIL = { method: 'GET', url: process.env.REACT_APP_BASE_URL + 'emails/{id}/preview' }
export const SAVE_EMAIL = { method: 'PUT', url: process.env.REACT_APP_BASE_URL + 'emails/{id}' }
// Entrances list
export const ENTRANCE_LIST_FILTERS = { method: 'GET', url: process.env.REACT_APP_BASE_URL + 'entrance/entrance-list-filters' }
export const GET_ENTRANCE_LIST = { method: 'GET', url: process.env.REACT_APP_BASE_URL + 'entrance/get-entrance-list' }
export const RESEND_ENTRANCE = { method: 'POST', url: process.env.REACT_APP_BASE_URL + 'entrance/resend-entrance' }
export const EXPORT_ENTRANCES = { method: 'GET', url: process.env.REACT_APP_BASE_URL + 'entrance/entrance-export' }
// Exposants list
export const GET_EXPOSANTS_LIST = { method: 'GET', url: process.env.REACT_APP_BASE_URL + 'exposant/get-exposant-list' }
export const CREATE_EXPOSANT = { method: 'POST', url: process.env.REACT_APP_BASE_URL + 'exposant' }
export const GET_PROMOTION_CODES = { method: 'GET', url: process.env.REACT_APP_BASE_URL + 'promotioncode' }

export function getUrlParameter(sParam) {
    const sPageURL = window.location.search.substring(1);
    const sURLVariables = sPageURL.split('&');

    for (let index = 0; index < sURLVariables.length; index++) {
        let sParameterName = sURLVariables[index].substring(0, sURLVariables[index].indexOf('='));
        let sParameterValue = sURLVariables[index].substring(sURLVariables[index].indexOf('=') + 1);

        if (sParameterName === sParam) {
            return sParameterValue === undefined ? true : sParameterValue;
        }
    }
    return false;
}

export async function getEventId() {
    if (document.cookie.indexOf('_eId=') < 0) {
        return request(NEXT_EVENT).then(async (jsonObject) => {
            document.cookie = '_eId=' + jsonObject.event.id;
            return jsonObject.event.id;
        })
    } else {
        let eventId = document.cookie.substring(document.cookie.indexOf('_eId=') + '_eId='.length);
        if (eventId != null && eventId.indexOf(';') > 0) {
            eventId = eventId.substring(0, eventId.indexOf(';'))
        }
        return eventId;
    }
}